<template>
    <basic-content-layout id="content-page" class="h-100">
        <div class="row container mt-5" style="margin: 0 auto;">
            <div class="col-12">
                <h1>{{$t('co.main.leads.title')}}</h1>
                <p class="subtitle">{{$t('co.main.leads.title.text')}}</p>
            </div>
            <div class="col-12 col-lg-8">
                <ad name="ad_above_checkout" class="mb-3"></ad>

                <div v-if="!isLoading">
                    <form @submit.prevent="submitHandler" method="POST" :action="this.$root.whitelabel.setting('leads_url')" ref="submitForm">
                        <checkout-leads-address />

                        <checkout-leads-billing-address/>

                        <div v-if="getCustomFields" class="mb-2">
                            <div class="row" v-for="(group, groupname) in getCustomFields">
                                <div class="seperator w-75 mb-4 mt-4"></div>

                                <b-form-group
                                    v-for="(field, index) in group"
                                    :label="field.label"
                                    :label-for="field.name"
                                    :key="index"
                                    class="col-12 col-md-5"
                                    :class="{ 'mr-md-2 mb-2': index % 2 === 0 }"
                                >

                                    <b-form-input
                                        v-if="field.type != 'textarea'"
                                        :id="field.name"
                                        :placeholder="field.label"
                                        :type="field.type"
                                        :name="field.name"
                                    ></b-form-input>

                                    <b-form-textarea 
                                        v-else
                                        :id="field.name"
                                        :name="field.name"
                                        class="w-100"
                                    ></b-form-textarea>
                                </b-form-group>
                            </div>

                        </div>

                        <div>
                            <b-form-checkbox class="pb-1" name="agbs" v-model="agbs" required>
                                <p v-html="$t('co.conclusion.confirm.privacy', {privacy: $getUrl('content-page', { path: 'datenschutz' })})"></p>
                            </b-form-checkbox>
                        </div>

                        <div v-if="this.$root.whitelabel.setting('leads_additional_checkbox')" class="d-flex">
                            <b-form-checkbox name="additional_checkbox" v-model="additionalCheckbox" required>
                                <p>{{ this.$root.whitelabel.setting('leads_additional_checkbox_label') }}</p>
                                <modal-leads-checkbox
                                    :header="this.$root.whitelabel.setting('leads_additional_checkbox_label')"
                                    :content="this.$root.whitelabel.setting('leads_additional_checkbox_content')"
                                    :visible="additionalCheckboxModal"
                                 />
                            </b-form-checkbox>

                            <font-awesome-icon icon="fa-info-circle" class="display-6 ml-2" @click="additionalCheckboxModal = !additionalCheckboxModal"/>
                        </div>
                        
                        <div ref="appenHiddenFields"></div>

                        <button 
                            type="submit" 
                            class="btn btn-primary mt-3"
                            :disabled="ageValidation"
                        >
                            {{ $t('co.button.leads.continue') }}
                        </button>
                    </form>

                    <div class="alert alert-info mt-3" v-if="isBroken">
                        {{$t('co.main.error')}}
                        <b-link :to="$getUrl('catalog')">{{$t('co.main.redirect')}}.</b-link>
                    </div>
                </div>

                <ad name="ad_below_checkout" class="mt-3"></ad>
            </div>
            <div class="col-12 col-lg-4 mt-3 mt-md-0" v-if="!isBroken">
                <div class="h-100">
                    <div :class="{ 'fixed': isFixed }">
                        <checkout-subscription-overview
                            :is-loading="isLoading"
                            :entry="entry"
                            :subscription="subscription"
                        ></checkout-subscription-overview>

                        <partner-contact-box
                            class="mt-4"
                            :entry="entry"
                            :is-loading="isLoading"
                        ></partner-contact-box>

                        <ad name="ad_below_contact" class="mt-3"></ad>
                    </div>
                </div>
            </div>
        </div>
    </basic-content-layout>
</template>

<script>
import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
import Ad from "../../components/atoms/Ad.vue";
import CheckoutSubscriptionOverview from "../../components/molecules/CheckoutSubscriptionOverview.vue";
import { EventBus } from "../../event-bus";
import PartnerContactBox from "../../components/molecules/PartnerContactBox.vue";
import CheckoutLeadsAddress from '../../components/molecules/CheckoutLeadsAddress.vue'
import CheckoutLeadsBillingAddress from '../../components/molecules/CheckoutLeadsBillingAddress.vue'
import ModalLeadsCheckbox from '../../components/molecules/ModalLeadsCheckbox.vue'

import {
    BFormInput, BFormGroup, BFormSelect, BFormSelectOption, BFormTextarea, BFormCheckbox, BLink
} from "bootstrap-vue"

export default {
    components: {
        Ad,
        BLink,
        BFormInput,
        BFormGroup,
        BFormSelect,
        BFormSelectOption,
        BFormTextarea,
        BasicContentLayout,
        BFormCheckbox,
        CheckoutSubscriptionOverview,
        CheckoutLeadsAddress,
        CheckoutLeadsBillingAddress,
        PartnerContactBox,
        ModalLeadsCheckbox
    },

    data() {
        return {
            ageValidation: true,
            isBroken: false,
            isLoading: false,
            subscription: null,
            entry: null,
            scrollPosition: null,
            agbs: null,
            additionalCheckbox: null,
            additionalCheckboxModal: false,
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.checkout.title')
            }
        },
        
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.checkout.description') }
            ]
        }
    },
    methods: {
        getEntryData(vehicle_uuid){
            this.isLoading = true

            this.$axios(`/api/v1/catalog/vehicle/${vehicle_uuid}`)
                .then(r => {
                    this.isLoading = false
                    this.entry = r.data.data
                    this.subscription.price_plan.fixed_duration = this.entry.fixed_duration
                    this.metaTitle = this.entry.title
                    this.googleAnalyticsInitEvent()
                })
                .catch(error => {
                    console.error(error)
                    this.isBroken = true
                    this.error = error.response.data.message
                })
        },

        updateScroll() {
            this.scrollPosition = window.scrollY
        },

        submitHandler() {
            this.$refs.appenHiddenFields.innerHTML = '';
            const leadsTrigger = !this.$root.whitelabel.setting('leads_trigger') === 'redirection';
            const form = new FormData(this.$refs.submitForm)
            const formData = Object.fromEntries(form.entries())
            let payload = {form: formData};

            if (this.$root.whitelabel.setting('leads_model_subsidiary')) {
                const subsidiaryData = {
                    name: this.entry.subsidiary.name,
                    email: this.entry.subsidiary.contact.email,
                    city: this.entry.subsidiary.contact.address.city,
                    street: this.entry.subsidiary.contact.address.street + ' ' + this.entry.subsidiary.contact.address.house_number,
                    zip: this.entry.subsidiary.contact.address.postal_code,
                    region: this.entry.subsidiary.contact.address.country,
                }

                if (leadsTrigger) {
                    this.appendInput('subsidiary', subsidiaryData)
                } else {
                    payload.subsidiary = subsidiaryData
                }
            }

            if (this.$root.whitelabel.setting('leads_model_vehicle')) {
                const vehicleData = {
                    id: this.entry.id,
                    partner_id: this.entry.partner_id,
                    vehicle: this.entry.title,
                    license_plate: this.entry.license_plate,
                    vin: this.entry.vin,
                }

                if (leadsTrigger) {
                    this.appendInput('vehicle', vehicleData)
                } else {
                    payload.vehicle = vehicleData
                }
            }

            if (this.$root.whitelabel.setting('leads_model_subscription')) {
                const subscriptionData = {
                    duration: this.subscription.price_plan.duration,
                    mileage: this.subscription.price_plan.mileage,
                    price: this.subscription.price_plan.price,
                    price_without_tax: this.subscription.price_plan.price_without_tax,
                    currency: this.subscription.price_plan.currency,
                }

                if (leadsTrigger) {
                    this.appendInput('subscription', subscriptionData)
                } else {
                    payload.subscription = subscriptionData
                }
            }

            this.$axios.post('/api/v1/leads/checkout/init_checkout', {
                vehicle_uuid: this.subscription.price_plan.vehicle_uuid,
                price: this.subscription.price_plan.price,
                mileage: this.subscription.price_plan.mileage,
                duration: this.subscription.price_plan.duration,
                payload: payload
            })
            .then(response => {
                if (response.data.success) {
                    if (this.$root.whitelabel.setting('leads_trigger') === 'webhook') {
                        this.$goTo('finish-leads');
                    } else {
                        this.$refs.submitForm.submit();
                    }
                } else if(response.data.success === 'webhook_failed') {
                    this.isBroken = true
                    console.error('Webook error!')
                } else {
                    this.isBroken = true
                    console.error($t('catalog.filter-localisation.error'))
                }
            })
            .catch(error => {
                console.error(error)
            })
        },

        appendInput(arrayName, value) {
            Object.entries(value).forEach(([key, value]) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = `${arrayName}_${key}`;
                input.value = value;

                this.$refs.appenHiddenFields.appendChild(input)
            })
        },

        googleAnalyticsInitEvent() {
            if (process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS && this.$gtag !== undefined && this.entry) {
                this.$gtag.event('begin_checkout', {
                    currency: this.subscription.price_plan.currency.toUpperCase(),
                    items: [
                        {
                            item_id: this.entry.id,
                            item_name: this.entry.title,
                            item_brand: this.entry.brand.title,
                            item_category: this.entry.category.title,
                            subsidiary_id: this.$root.whitelabel.sub_id(),
                            price: this.subscription.price_plan.price,
                            mileage: this.subscription.price_plan.mileage,
                            duration: this.subscription.price_plan.duration
                        }
                    ]
                })
            }
        }
    },

    computed: {
        isFixed() {
            return this.scrollPosition > 81
        },

        getCustomFields() {
            const customFields = this.$root.whitelabel.setting('leads_custom_fields');

            if (!customFields) {
                return false
            }
            
            let sortFields = {}

            customFields.forEach(field => {
                if (!sortFields[field.group]) {
                    sortFields[field.group] = []
                }

                sortFields[field.group].push({
                    name: field.name,
                    label: field.label,
                    type: field.type,
                })
            });

            return sortFields
        }
    },

    destroyed() {
        window.removeEventListener('scroll', this.updateScroll)
    },

    mounted() {
        EventBus.$on('leads-age-validation', (data) => {
            if (data.value) {
                this.ageValidation = false
            } else {
                this.ageValidation = true
            }
        });

        this.subscription = { price_plan: JSON.parse(this.$route.params.identifier) }
        this.getEntryData(this.subscription.price_plan.vehicle_uuid)
        window.addEventListener('scroll', this.updateScroll)
    },
}
</script>
<style>
.seperator {
    height: 1px;
    background-color: lightgray;
}

.info-icon {
    font-size: 1rem;
}
</style>